import { motion } from 'framer-motion';
import Header from '../Header';
import Footer from '../Footer';

const reasons = [
  {
    label: 'For teams',
    description: 'Standardize strategic deliverables across your organization.',
  },
  {
    label: 'For consultants',
    description: 'Create governance-ready artifacts for every client engagement.',
  },
  {
    label: 'For enterprise',
    description: 'Governance, compliance, and strategic alignment at scale.',
  },
  {
    label: 'Partnerships',
    description: 'Integrations, co-builds, and ecosystem opportunities.',
  },
  {
    label: 'Press & media',
    description: "Stories, interviews, and coverage of what we're building.",
  },
  {
    label: 'Everything else',
    description: 'Ideas, feedback, or just to say hi.',
  },
];

export default function Contact() {
  return (
    <div className="min-h-screen bg-brand-900 flex flex-col">
      <Header />

      <main className="flex-grow">
        {/* Hero */}
        <section className="pt-32 pb-24 px-6 md:px-12">
          <div className="max-w-4xl mx-auto">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7 }}
            >
              <p className="text-sm font-bold text-brand-500 uppercase tracking-widest mb-6">
                Contact
              </p>
              <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold tracking-tighter leading-[0.9] text-brand-50 mb-10">
                Let's talk<br />
                <span className="text-brand-500">strategy.</span>
              </h1>
              <p className="text-xl md:text-2xl text-brand-400 font-light leading-relaxed max-w-2xl">
                Whether you're building something ambitious, exploring a partnership, or just
                curious about what Pabs can do, we'd love to hear from you.
              </p>
            </motion.div>
          </div>
        </section>

        {/* Email CTA */}
        <section className="pb-24 px-6 md:px-12">
          <div className="max-w-4xl mx-auto">
            <motion.div
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.2 }}
              className="inline-flex flex-col sm:flex-row items-start sm:items-center gap-6"
            >
              <a
                href="mailto:hello@pabs.co.nz"
                className="group inline-flex items-center gap-4 h-16 px-8 bg-brand-50 text-brand-900 rounded-full font-bold text-lg hover:bg-brand-200 transition-all duration-300 shadow-xl"
              >
                hello@pabs.co.nz
                <svg
                  className="w-5 h-5 transition-transform duration-300 group-hover:translate-x-1"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </a>
              <span className="text-brand-500 text-sm font-medium">We reply within 24 hours.</span>
            </motion.div>
          </div>
        </section>

        {/* Reasons grid */}
        <section className="py-20 px-6 md:px-12 border-t border-brand-800">
          <div className="max-w-4xl mx-auto">
            <p className="text-sm font-bold text-brand-600 uppercase tracking-widest mb-12">
              What we can help with
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-12 gap-y-10">
              {reasons.map((item, idx) => (
                <motion.div
                  key={idx}
                  initial={{ opacity: 0, y: 12 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: idx * 0.07 }}
                >
                  <h3 className="text-base font-bold text-brand-50 mb-2">{item.label}</h3>
                  <p className="text-sm text-brand-500 leading-relaxed">{item.description}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
